import { useData } from '@app/data/repositories';
import { ClientsScreen } from './ClientsScreen';
import { useClients } from './useClients';

/** Вход списка клиентов. */
export function ClientsRoute({
  onOpenClient,
  creating,
  onCreatingChange,
}: {
  onOpenClient: (id: string) => void;
  creating: boolean;
  onCreatingChange: (creating: boolean) => void;
}) {
  const { db } = useData();
  const { state, actions } = useClients(db);

  return (
    <ClientsScreen
      state={state}
      actions={actions}
      onOpenClient={onOpenClient}
      creating={creating}
      onCreatingChange={onCreatingChange}
    />
  );
}
